<template>
  <span class="n-number-unit">{{ label }}</span>
</template>

<script setup>
import {computed} from 'vue';
import {useBootstrap} from '@front/hooks';

const props = defineProps({
  name: [String, Array],
  value: undefined,
  placeholder: { type: String, default: '-' },
});

const { ENUMS } = useBootstrap();

const label = computed(() => {
  const value = props.value;
  const placeholder = props.placeholder;
  if (!value) return placeholder;
  const currencies = value.split('/');
  if (currencies.length !== 2) return placeholder;
  const { Currency } = ENUMS.value;
  const depositCurrency = Currency.find(o => o.value === currencies[0])?.label;
  const accountCurrency = Currency.find(o => o.value === currencies[1])?.label;
  return `${depositCurrency}/${accountCurrency}`;
});
</script>

<style lang="less">
.n-number-unit {
  font-size: 10px;
  font-weight: bold;
  opacity: 0.6;
}
</style>
